import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface SurveySubmission {
  question: string;
  skipped: boolean;
  score?: number;
  description?: string;
}

export interface SurveyResponse {
  id: string;
  modified_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly apiBaseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Submit survey response
   * POST /api/v1/chat/{conversation_id}/user_metadata/surveys
   */
  submitSurvey(conversationId: string, survey: SurveySubmission): Observable<SurveyResponse> {
    const url = `${this.apiBaseUrl}/api/v1/chat/${conversationId}/user_metadata/surveys`;
    return this.http.post<SurveyResponse>(url, survey);
  }
}
